import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";

/* ---------------- TOP FEATURED TABS ---------------- */
const Ftabs = [
  {
    key: "cogeneration",
    label: "Cogeneration",
    viewAllText: "View all Cogeneration Plants",
    viewAllPath: "/cogeneration",
  },
  {
    key: "powergeneration",
    label: "Power Generation",
    viewAllText: "View all Power Generation Plants",
    viewAllPath: "/powergenerationplants",
  },
  {
    key: "renewable",
    label: "Renewable Energy",
    viewAllText: "View all Renewable Energy Plants",
    viewAllPath: "/renewableenergyindia",
  },
  {
    key: "agency",
    label: "Renewable Agency",
    viewAllText: "View all Renewable Agencies",
    viewAllPath: "/renewableagenciesindia",
  },
];

/* ---------------- LEFT NAV ---------------- */
const leftTabs = [
  { key: "cogeneration", label: "Cogeneration", path: "/cogeneration" },
  {
    key: "powergeneration",
    label: "Power Generation",
    path: "/powergenerationplants",
  },
  {
    key: "renewable",
    label: "Renewable Energy",
    path: "/renewableenergyindia",
  },
  { key: "agency", label: "Renewable Agency", path: "/renewableagenciesindia" },
];

function Powerplant() {
  const location = useLocation();

  const defaultTab =
    leftTabs.find((tab) => location.pathname.includes(tab.path))?.key ||
    "cogeneration";

  const [activeTab, setActiveTab] = useState(defaultTab);
  const [powerplantData, setPowerplantData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const activeTabMeta = Ftabs.find((t) => t.key === activeTab);
  const slugify = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "");

  /* ---------------- FETCH FEATURED DATA ---------------- */
  useEffect(() => {
    const fetchFeaturedPowerplants = async () => {
      try {
        const res = await axios.get(
          "https://backend-zkgn.onrender.com/api/powerplants/featured",
        );

        if (res.data.success) {
          setPowerplantData(res.data.data);
        } else {
          setError("Failed to load powerplant data");
        }
      } catch (err) {
        console.error(err);
        setError("Server error while fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedPowerplants();
  }, []);

  return (
    <section className="featured-powerplants py-4">
      <div className="container-fluid px-lg-5">
        <div className="row">
          {/* ================= LEFT NAV ================= */}
          <div className="col-lg-3 mb-4 mb-lg-0">
            <div className="powerplant-tabs">
              <h5 className="tab-title">Powerplants</h5>
              <ul className="list-group">
                {leftTabs.map((tab) => (
                  <Link
                    key={tab.key}
                    to={tab.path}
                    className={`list-group-item ${
                      activeTab === tab.key ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    {tab.label}
                  </Link>
                ))}
              </ul>
            </div>
          </div>

          {/* ================= FEATURED ================= */}
          <div className="col-lg-9">
            <div className="featured-box">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="fw-bold mb-0">Featured Powerplants</h5>
                {activeTabMeta && (
                  <Link
                    to={activeTabMeta.viewAllPath}
                    className="view-all-link"
                  >
                    {activeTabMeta.viewAllText} →
                  </Link>
                )}
              </div>

              {/* TOP TABS */}
              <div className="featured-tabs mb-3">
                <div className="row g-2">
                  {Ftabs.map((tab) => (
                    <div key={tab.key} className="col-6 col-sm-4 col-lg-auto">
                      <button
                        className={`featured-tab w-100 ${
                          activeTab === tab.key ? "active" : ""
                        }`}
                        onClick={() => setActiveTab(tab.key)}
                      >
                        {tab.label}
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              {/* LOADING / ERROR */}
              {loading && <p className="text-muted">Loading powerplants…</p>}
              {error && <p className="text-danger">{error}</p>}

              {/* PLANT LIST */}
              <div className="row g-3">
                {!loading &&
                  powerplantData[activeTab]?.map((plant) => (
                    <div key={plant.id} className="col-md-3 col-sm-6">
                      <div className="powerplant-card text-center">
                        <Link
                          to={`/${
                            activeTab === "cogeneration"
                              ? "cogenerationinfo"
                              : activeTab === "powergeneration"
                                ? "powergeneration"
                                : activeTab === "renewable"
                                  ? "renewableenergy"
                                  : "renewableagency"
                          }/${slugify(plant.name)}/${plant.id}`}
                          className="powerplant-name"
                        >
                          {plant.name}
                        </Link>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Powerplant;
